import React, { useState, useEffect } from 'react';
import GridAdd from '../../../../components/GridAdd/GridAdd';
import { Color } from '../../../../const/Const';
import { API } from '../../../../API/API';
import HrEmpInvalNew from './New/HrEmpInvalNew';
import { hideLoadScreen, showLoadScreen } from '../../../../components/LoadScreen/LoadScreen';
import { useParams } from 'react-router-dom';

const HrEmpInval = (props) => {

    const params = useParams();
    const [empid, setEmpId] = useState(-1);
    const [onOpen, setOnOpen] = useState(false);
    const [data, setData] = useState([]);
    const [entryid, setEntryid] = useState();

    const getExistsData = async () => {
        let tData = [];
        if (empid > 0) {
            showLoadScreen();
            await API.get('/api/humanresource/employee/invalid?empid=' + empid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata) {
                        tData = response.data.retdata;
                    }
                }
            })
            hideLoadScreen();
        }
        setData(tData);
    }

    useEffect(() => {
        let tEmpId = -1;
        if (params.empid) {
            tEmpId = params.empid;
        }
        setEmpId(tEmpId);
    }, [params]);

    useEffect(() => {
        getExistsData();
    }, [empid]);

    const onDismiss = () => {
        setEntryid(null);
        setOnOpen(false);
    }

    const onEdit = (p_id) => {
        setEntryid(p_id);
        setOnOpen(true);
    }

    const afterSave = async (p_close) => {
        setEntryid(null);
        if (p_close) {
            setOnOpen(false);
        }
        getExistsData();
    }

    return (
        <div style={{ padding: 8 }}>
            <div>
                <GridAdd
                    title={`Хөгжлийн бэрхшээл ${data.length > 4 ? `(${data.length})` : ""}`}
                    description=""
                    onNew={() => { setEntryid(); setOnOpen(true); }}
                    data={data}
                    columns={[{
                        name: 'ХЧА шалтгаан',
                        fieldName: 'reasonname',
                        maxWidth: 160,
                        minWidth: 120,
                        onRender: (item) => {
                            return (
                                <div
                                    onClick={() => onEdit(item.entryid)}
                                    style={{ color: Color.blue, cursor: 'pointer' }}
                                >
                                    {item.reasonname ?? item.entryid}
                                </div>
                            );
                        }
                    },
                    {
                        name: 'Өвчний ангилал',
                        fieldName: 'illnessname'
                    },
                    {
                        name: 'Групп тогтоосон огноо',
                        fieldName: 'invalidbegdate'
                    },
                    {
                        name: 'Үргэлжлэх хугацаа',
                        fieldName: 'durationname'
                    },
                    {
                        name: 'ХХОАТ төлөх эсэх',
                        fieldName: 'paytax'
                    },
                    {
                        name: 'Комиссын шийдвэр',
                        fieldName: 'decisionname'
                    }]}
                />
                <HrEmpInvalNew
                    entryid={entryid}
                    empid={empid}
                    onOpen={onOpen}
                    onDismiss={onDismiss}
                    afterSave={afterSave} />
            </div>
        </div>
    );
}

export default HrEmpInval;